import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[5]}px;
      background-color: ${theme.panel.solid};
      padding: ${theme.spacing[6]}px;
      border-radius: ${theme.radius[5]}px;
    `;
  }};
`;

export const ContainerListagem = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[5]}px;
    `;
  }};
`;

export const CategoriaTitulo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* padding: 0 ${({ theme }) => theme.spacing[6]}px; */
`;
